import { LabelId } from '@this+that/models';

import {
  EmailAction,
  getLabelIdsForAction,
} from '../../../utils/emailLabelHelpers';

type UpdateLabelsInInboxEntries = (
  messageIds: string[],
  updateLabels: (currentLabels: LabelId[] | undefined) => LabelId[],
) => void;

// One call covers every communication: updateLabels runs per-communication
// against its own current labelIds inside the store handler, so a single
// messageIds batch is safe even though getLabelIdsForAction's result differs
// per starting label set.
export const applyOptimisticEntryLabelHide = (
  updateUserCommunicationLabelsInInboxEntries: UpdateLabelsInInboxEntries,
  messageIds: string[],
  action: EmailAction,
): void => {
  if (messageIds.length === 0) {
    return;
  }
  updateUserCommunicationLabelsInInboxEntries(messageIds, (currentLabels) =>
    getLabelIdsForAction(currentLabels, action),
  );
};

// Restores each message to its own backed-up labels — one call per id, since
// the restore target is a fixed value per message, not a function of the
// (already-mutated) current labels.
export const revertOptimisticEntryLabelHide = (
  updateUserCommunicationLabelsInInboxEntries: UpdateLabelsInInboxEntries,
  messageIds: string[],
  labelBackupMap: Map<string, LabelId[]>,
): void => {
  messageIds.forEach((messageId) => {
    const previousLabels = labelBackupMap.get(messageId);
    if (previousLabels) {
      updateUserCommunicationLabelsInInboxEntries(
        [messageId],
        () => previousLabels,
      );
    }
  });
};
